var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActivityDailyActivityViewEntries(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 600 600",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#d4bff6;}.cls-2,.cls-3{fill:#784ace;}.cls-3{opacity:0.98;}.cls-4{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "activity_daily_activity_view_entries"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 299.9,
    cy: 300.77,
    r: 272.66
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M275.77,370.33a21.15,21.15,0,0,0-15.47-6.25H218l25.09-26.67a154.1,154.1,0,0,0,25.14-35.51c6.39-12.7,9.64-25.29,9.64-37.44a68.85,68.85,0,0,0-8.23-33.64A60.12,60.12,0,0,0,246,207.13c-10.1-5.65-21.9-8.52-35.05-8.52-9.33,0-19.12,2.33-29.11,6.92a89.93,89.93,0,0,0-26.08,18.09,67.47,67.47,0,0,0-9.11,10.82,21.76,21.76,0,0,0-3.76,11.82c0,5.68,2.4,10.76,7.13,15.1a22.33,22.33,0,0,0,15.42,6.35,21.54,21.54,0,0,0,17.71-9.13,53.85,53.85,0,0,1,13.19-12.74c4.42-2.92,8.56-4.33,12.67-4.33,6,0,11.21,2.35,15.9,7.19A23.59,23.59,0,0,1,232,265.84c0,5.18-1.75,11.1-5.2,17.6a100.78,100.78,0,0,1-15.17,20.86l-60.1,64.23A23.29,23.29,0,0,0,144.81,385a22,22,0,0,0,5.84,15.6c4,4.24,9.32,6.4,15.88,6.4H260.3a21.37,21.37,0,0,0,15.4-6.05A20.56,20.56,0,0,0,282,385.81a21.11,21.11,0,0,0-6.25-15.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M436.46,311.68V224.47A22.67,22.67,0,0,0,430,208.1a21.62,21.62,0,0,0-16.08-6.73,23,23,0,0,0-18.65,8.93L308.15,317a23,23,0,0,0-5.59,15,21.43,21.43,0,0,0,7.26,16.06c4.67,4.3,9.91,6.49,15.56,6.49h65.43v29.3a22.71,22.71,0,0,0,6.46,16.37A21.67,21.67,0,0,0,413.36,407a22.76,22.76,0,0,0,23.1-23.1v-72.2Zm-45.65-31.15v31.15H365.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M599.47,278.65a26.91,26.91,0,1,0-53.81,0s0,14.67,0,22.11c0,135.53-110.23,245.76-245.75,245.76S54.14,436.29,54.14,300.76,164.39,55,299.9,55A245.16,245.16,0,0,1,467,120.7a247.86,247.86,0,0,1,33.12,37.67v4.38c1,0,2-.08,2.94-.17a32.77,32.77,0,0,0,29.4-32.34V130l.13-16.48h1c-.32-.42-.64-.81-1-1.21a302.23,302.23,0,0,0-65.06-59.7A297.87,297.87,0,0,0,299.9,1.19C134.72,1.19.32,135.59.32,300.76S134.72,600.34,299.9,600.34,599.47,466,599.47,300.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M516.63,164.67a26.91,26.91,0,0,1-26.91-26.91V40.66a26.91,26.91,0,1,1,53.81,0v97.1A26.9,26.9,0,0,1,516.63,164.67Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 419.64,
    y1: 137.76,
    x2: 516.74,
    y2: 137.76
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M516.74,164.67h-97.1a26.91,26.91,0,0,1,0-53.82h97.1a26.91,26.91,0,0,1,0,53.82Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActivityDailyActivityViewEntries);
export default __webpack_public_path__ + "static/media/activity_daily_activity_view_entries.78beb8103189669604a7b89167f7d1f4.svg";
export { ForwardRef as ReactComponent };